import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "@/lib/http";

export type ApiPlan = {
  id: string;
  name: string;
  description: string;
  price: number;
};
async function getApiPlans() {
  return await api.payment.get<Array<ApiPlan>>(
    "v1/api-services/subscriptions-types",
  );
}

export const apiPlansQueryOptions = queryOptions({
  queryKey: ["api-plans"],
  async queryFn() {
    const res = await getApiPlans();
    const data = await res.json();
    return { res, data };
  },
  select({ data }) {
    return data;
  },
});

export function useApiPlans() {
  return useQuery(apiPlansQueryOptions);
}
